import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartscreeninline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M46 48h2l9 13H7l9-13h2" }),
			/* @__PURE__ */ _jsx("path", { d: "M22 45h20v6a2 2 0 0 1-2 2H24a2 2 0 0 1-2-2v-6z" }),
			/* @__PURE__ */ _jsx("rect", {
				width: 28,
				height: 42,
				x: 18,
				y: 3,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 34,
				x: 22,
				y: 7,
				rx: 1
			})
		]
	})
});
export default SvgSmartscreeninline;
